// Guided lesson -> Sandbox mapping. Each guided scenario names the simulator
// lab and scenario that reproduce the same behavior hands-on. A null entry
// means the guided story has no simulator equivalent yet, and no button is
// shown.
export const GUIDED_LINKS = {
  1: {
    'reply-loss': { labId: 'lab1', scenario: 'droppedReplyCached' },
    'request-loss': { labId: 'lab1', scenario: 'droppedRequest' },
    'stale-reply': { labId: 'lab1', scenario: 'staleReplyIgnored' },
  },
  2: {
    'install-view': { labId: 'lab2', scenario: 'backupJoin' },
    'replicated-rpc': { labId: 'lab2', scenario: 'normalReplicatedOp' },
    failover: { labId: 'lab2', scenario: 'primaryCrashFailover' },
  },
  3: {
    stable: { labId: 'lab3', scenario: 'normalReplication' },
    loss: { labId: 'lab3', scenario: 'lostPhase2' },
    failover: { labId: 'lab3', scenario: 'leaderCrashRecovery' },
    partition: { labId: 'lab3', scenario: 'minorityStall' },
    membership: null,
    'garbage-collection': { labId: 'lab3', scenario: 'logCompaction' },
  },
  4: {
    'single-key': { labId: 'lab4', scenario: 'queryAndRoute' },
    reconfigure: { labId: 'lab4', scenario: 'moveShard' },
    'two-phase-commit': { labId: 'lab4', scenario: 'crossGroupTxn' },
    abort: { labId: 'lab4', scenario: 'abortAndRetry' },
  },
};

export function guidedLink(guidedLabId, guidedScenarioId) {
  const lab = GUIDED_LINKS[guidedLabId];
  if (!lab) return null;
  return lab[guidedScenarioId] || null;
}
